module.exports = __webpack_public_path__ + "img/pic1.3bd04d20.jpg";